import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { getUserSolutionsApi } from '../api';
export var ACCOUNT_ADMIN = 'AccountAdministrator'; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

export var getSFxUser = function getSFxUser(props) {
  var user;

  if (localStorage.getItem('OIDCUSER')) {
    try {
      var OIDCUSER = localStorage.getItem('OIDCUSER');
      user = OIDCUSER && JSON.parse(OIDCUSER);

      if (user) {
        var _user = user,
            _user$profile = _user.profile,
            _user$profile$key = _user$profile.key,
            _key = _user$profile$key === void 0 ? '' : _user$profile$key,
            _user$profile$Account = _user$profile.AccountId,
            AccountId = _user$profile$Account === void 0 ? '' : _user$profile$Account,
            _user$profile$email = _user$profile.email,
            email = _user$profile$email === void 0 ? '' : _user$profile$email,
            _user$access_token = _user.access_token,
            access_token = _user$access_token === void 0 ? '' : _user$access_token;

        user.SFxPrivilege = getSFxPrivilege(user);
        user.SFxRole = getSFxRole(user);
        user.hasUsersPrivilege = getHasUsersPrivilege(user);
        user.userId = _key;
        user.orgId = AccountId;
        user.email = email;
        user.access_token = access_token;
      }

      return user;
    } catch (error) {
      user = {
        SFxPrivilege: [],
        SFxRole: [],
        hasUsersPrivilege: false,
        userId: '',
        orgId: '',
        email: '',
        access_token: '',
        profile: {
          PlatformUrl: ''
        }
      };
      return user;
    }
  } else if (process.env.NODE_ENV === 'development') {
    var _access_token = localStorage.getItem('react-ui-local-token');

    return _objectSpread(_objectSpread({}, props), {}, {
      access_token: _access_token
    });
  } else {
    return props;
  }
};
export var getSFxRole = function getSFxRole(user) {
  var _user$profile$SFxRole = user.profile.SFxRole,
      SFxRole = _user$profile$SFxRole === void 0 ? '' : _user$profile$SFxRole;
  SFxRole = SFxRole ? Array.isArray(SFxRole) ? SFxRole : [SFxRole] : null;
  return SFxRole;
};
export var getSFxPrivilege = function getSFxPrivilege(user) {
  var _user$profile$SFxPriv = user.profile.SFxPrivilege,
      SFxPrivilege = _user$profile$SFxPriv === void 0 ? '' : _user$profile$SFxPriv;
  SFxPrivilege = SFxPrivilege ? Array.isArray(SFxPrivilege) ? SFxPrivilege : [SFxPrivilege] : null;
  return SFxPrivilege;
};
export var getHasUsersPrivilege = function getHasUsersPrivilege(user) {
  var SFxPrivilege = getSFxPrivilege(user);
  return SFxPrivilege ? SFxPrivilege.indexOf('users') > -1 : false;
};
export var fetchSolutions = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$getUserSolutio, data, solutions;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return getUserSolutionsApi();

          case 3:
            _yield$getUserSolutio = _context.sent;
            data = _yield$getUserSolutio.data;
            solutions = data.map(function (r) {
              var slnIcon = r.images && r.images[0];
              var defaultIconUrl = r.defaultImageUrl;
              var solutionIconUrl = slnIcon && slnIcon.url ? slnIcon.url : defaultIconUrl;
              return {
                url: r.clientUri ? r.clientUri : '/',
                id: r.id,
                name: r.name,
                shortName: r.shortName,
                img: solutionIconUrl
              };
            });
            setSFxSolutions(solutions);
            return _context.abrupt("return", solutions);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", []);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 10]]);
  }));

  return function fetchSolutions() {
    return _ref.apply(this, arguments);
  };
}();
var SFxSolutions = [];
export var setSFxSolutions = function setSFxSolutions(solutions) {
  SFxSolutions = solutions;
};
export var getSFxSolutions = function getSFxSolutions() {
  return SFxSolutions;
};
export var setTabIcon = function setTabIcon(solutions, currentSolutionId) {
  var currentSolution = solutions.filter(function (item) {
    return item.id === currentSolutionId;
  })[0];

  if (currentSolution) {
    var solutionImg = currentSolution.img;

    if (solutionImg) {
      var link = document.createElement('link'),
          oldLink = document.querySelector("link[rel*='shortcut icon']");
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = solutionImg;

      if (oldLink) {
        document.head.removeChild(oldLink);
      }

      document.head.appendChild(link);
    }
  }
};